module.exports = __webpack_public_path__ + "img/logo2.835cd90e.png";